import { useRef, useEffect } from 'react'

export default function AudioPreviewModal({onClose, audio}) {
    const audioRef = useRef(null)

    useEffect(() => {
        return () => {
            if (audioRef.current) {
                audioRef.current.pause()
                audioRef.current.src = ''
            }
        }
    }, [])

    return (
        <div className="">
            <audio ref={audioRef} src={audio.url} autoPlay controls />
        </div>
    )
}